import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';
import { CashDropForm } from './CashDropForm';

// Alert Bar Nested Actions
export const CASH_DROP_ALERT_BAR_ACTION = 'cashDrop/CASH_DROP_ALERT_BAR_ACTION';
export const cashDropAlertBarAction = Nested.nestedAction(
  CASH_DROP_ALERT_BAR_ACTION,
);

// Modal Nested Actions
export const MODAL_ACTION = 'cashDrop/MODAL_ACTION';
export const cashDropModalAction = Nested.nestedAction(MODAL_ACTION);

// Action Creators and Action Types
export const CASH_DROP_FORM_ACTION = 'cashDrop/CASH_DROP_FORM_ACTION';
export const cashDropFormAction = Nested.nestedAction(CASH_DROP_FORM_ACTION);

export const SUBMIT_CASH_DROP_FORM = 'cashDrop/SUBMIT_CASH_DROP_FORM';
export const submitCashDropForm = (payload) => ({
  type: SUBMIT_CASH_DROP_FORM,
  payload,
});

export const CASH_DROP_SUCCESS = 'cashDrop/CASH_DROP_SUCCESS';
export const postCashDropSuccess = (payload) => ({
  type: CASH_DROP_SUCCESS,
  payload,
});

export const CASH_DROP_ERROR = 'cashDrop/CASH_DROP_ERROR';
export const postCashDropError = (payload) => ({
  type: CASH_DROP_ERROR,
  payload,
});

// Default State
const initialState = {
  data: {},
  batch: {},
  error: false,
  isLoading: false,
};
// Raw Reducer
export const _reducer = (state = initialState, { type /* , payload */ }) => {
  switch (type) {
    case SUBMIT_CASH_DROP_FORM:
      return {
        ...state,
        isLoading: true,
      };
    case CASH_DROP_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.cashDrop,
  terminalSession: state.terminalLogin.terminalSession,
});
export const _mapDispatchToProps = (dispatch) => ({
  submitCashDropForm: (payload) => dispatch(submitCashDropForm(payload)),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    alertBars: {
      cashDropAlertBars: {
        ...AlertBarState,
        actionType: CASH_DROP_ALERT_BAR_ACTION,
      },
    },
    forms: {
      cashDropForm: {
        ...CashDropForm,
        actionType: CASH_DROP_FORM_ACTION,
      },
    },
  },
  'cashDrop',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
